import { render, staticRenderFns } from "./FileDetail.vue?vue&type=template&id=1b6c58da&scoped=true&"
import script from "./FileDetail.vue?vue&type=script&lang=js&"
export * from "./FileDetail.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/fileDetail.less?vue&type=style&index=0&id=1b6c58da&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6c58da",
  null
  
)

export default component.exports